"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.signatureInputSchema = void 0;
exports.default = SignatureInput;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const zod_1 = require("zod");
const react_hook_form_1 = require("react-hook-form");
const react_signature_canvas_1 = __importDefault(require("react-signature-canvas"));
const material_1 = require("@mui/material");
const SignatureInput_styles_1 = require("./SignatureInput.styles");
exports.signatureInputSchema = ((options) => {
    return {
        options,
        create: (fieldName, validation) => {
            return zod_1.z.object({ [fieldName]: validation });
        },
    };
})({
    default: zod_1.z.string().min(1, 'Required'),
    notRequired: zod_1.z.string().nullable(),
});
function SignatureInput({ name, label, helperText }) {
    var _a, _b, _c;
    const theme = (0, material_1.useTheme)();
    const signatureCanvasRef = (0, react_1.useRef)(null);
    const labelId = (0, react_1.useId)();
    const { control } = (0, react_hook_form_1.useFormContext)();
    const { field } = (0, react_hook_form_1.useController)({ name, control });
    const setFieldValue = () => {
        if (signatureCanvasRef.current) {
            field.onChange(signatureCanvasRef.current.toDataURL());
        }
    };
    (0, react_1.useEffect)(() => {
        if (!field.value && signatureCanvasRef.current) {
            signatureCanvasRef.current.clear();
        }
    }, [field.value]);
    return ((0, jsx_runtime_1.jsxs)(material_1.FormControl, { fullWidth: true, children: [label ? ((0, jsx_runtime_1.jsx)(material_1.FormLabel, { id: labelId, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "bodyMediumBook", children: label }) })) : null, (0, jsx_runtime_1.jsx)(react_signature_canvas_1.default, Object.assign({ canvasProps: {
                    'aria-describedby': labelId,
                    'aria-label': 'Signature input',
                    role: 'img',
                    style: (0, SignatureInput_styles_1.signatureCanvasStyles)((_a = theme.palette.primary) === null || _a === void 0 ? void 0 : _a.main),
                }, backgroundColor: `${(_b = theme.palette.backgrounds) === null || _b === void 0 ? void 0 : _b.neutral}` }, field, { ref: signatureCanvasRef, onEnd: () => setFieldValue() })), (0, jsx_runtime_1.jsx)(material_1.Box, { sx: Object.assign({}, (0, SignatureInput_styles_1.signatureLineStyles)((_c = theme.palette.primary) === null || _c === void 0 ? void 0 : _c.main)) }), (0, jsx_runtime_1.jsxs)(material_1.Grid, { container: true, direction: "row", justifyContent: "space-between", children: [(0, jsx_runtime_1.jsxs)(material_1.Grid, { item: true, children: [helperText ? ((0, jsx_runtime_1.jsx)(material_1.Typography, { sx: { display: 'block' }, variant: "bodySmallBook", children: helperText })) : null, (0, jsx_runtime_1.jsxs)(material_1.Typography, { variant: "bodySmallBook", children: ["Date: ", new Date().toLocaleDateString()] })] }), (0, jsx_runtime_1.jsx)(material_1.Grid, { item: true, children: (0, jsx_runtime_1.jsx)(material_1.Button, { variant: "primaryHC", onClick: () => field.onChange(null), children: "Clear" }) })] })] }));
}
//# sourceMappingURL=SignatureInput.js.map